import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../../../helpers/export'
import SecurityService from '../../core/SecurityService'

export const postCapitalEarningLeverage = createAsyncThunk(
  'companyAnalysis/industryAnalysis/securities/capitalEarningLeverage',
  async (params, { rejectWithValue }) => {
    try {
      const res = await SecurityService.postCapitalEarningLeverage(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const downloadCapitalEarningLeverage = createAsyncThunk(
  'companyAnalysis/industryAnalysis/securities/capitalEarningLeverage/export',
  async (params) => {
    try {
      const res = await SecurityService.downloadCapitalEarningLeverage(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)
